import styled, { keyframes } from 'styled-components';
import { px2rem } from '../../../helpers/rem.mjs';

var bubblingAnimation = keyframes(["0%{transform:translateY(0);}100%{transform:translateY(", ");}"], px2rem(-5));
var sizeMap = new Map([["l", 14], ["s", 6]]);
var BubblingItem = styled.span.withConfig({
  displayName: "BubblingItem",
  componentId: "sc-1sd419h-0"
})(["display:inline-block;vertical-align:middle;border-radius:50%;animation:", " 0.275s cubic-bezier(0.55,0.055,0.675,0.19) infinite alternate;& ~ &{margin-left:", ";}&:nth-of-type(2){animation-delay:0.075s;}&:nth-of-type(3){animation-delay:0.15s;}"], bubblingAnimation, px2rem(5));
var BubblingG = styled.div.withConfig({
  displayName: "BubblingG",
  componentId: "sc-1sd419h-1"
})(["width:100%;display:flex;justify-content:center;position:relative;top:calc(50% - ", ");", "{width:", ";height:", ";background:", ";}", ""], px2rem(6), BubblingItem, function (props) {
  return px2rem(sizeMap.get(props.size));
}, function (props) {
  return px2rem(sizeMap.get(props.size));
}, function (props) {
  return props.color || props.theme.colorV2.accent;
}, function (props) {
  return props.overrideStyle;
});

export { BubblingG, BubblingItem };
